import React, { useState } from 'react';

const TINTS = [
  '#00449D',
  '#0C447C',
  '#1B605D',
  '#3F526E',
  '#072B5E',
  '#0F6E56',
];

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/);
  const result = ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase();
  return result || '?';
}

export interface AvatarProps {
  name: string;
  /** Photo URL. When absent or it fails to load, the tinted initials show instead. */
  src?: string | null;
  size?: number;
}

export const Avatar = ({ name, src, size = 28 }: AvatarProps) => {
  const [failed, setFailed] = useState(false);

  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  const bg = TINTS[h % TINTS.length];
  const showImage = !!src && !failed;

  return (
    <span
      className="tw-rounded-full tw-text-white tw-font-poppins tw-font-semibold tw-inline-flex tw-items-center tw-justify-center tw-flex-none tw-overflow-hidden"
      style={{
        width: size,
        height: size,
        background: bg,
        fontSize: Math.round(size * 0.36),
      }}
    >
      {showImage ? (
        <img
          src={src as string}
          alt={name}
          onError={() => setFailed(true)}
          className="tw-w-full tw-h-full tw-object-cover"
        />
      ) : (
        initialsOf(name)
      )}
    </span>
  );
};
